import type { FormFieldTypeId } from '@witmetrics/utils';
import { FIELD_TYPES } from '@witmetrics/utils/constants';

export const LABELS = Object.values(FIELD_TYPES).reduce(
  (a, { id, label }) => ({
    ...a,
    [id]: label,
  }),
  {} as Record<FormFieldTypeId, string>
);
